$(document).ready(function() {
    reformatDatePickerInputOnSubmit();
});

function reformatDatePickerInputOnSubmit() {
    const datePickers = $('.usa-date-picker__external-input');
    datePickers.parents('form').on('submit', function (event) {
        datePickers.each(function(i, datePicker) {
            datePicker.value = new Date(datePicker.value).toISOString().substring(0, 10);
        })
    });
}